import React from "react";
const TabNavItem = ({ id, title, activeTab, setActiveTab }) => {
  const handleClick = () => {
    setActiveTab(id);
  };

  return (
    <li
      onClick={handleClick}
      id="step"
      className={activeTab === id ? "active" : ""}
      style={activeTab === id ? { color: "#4cb88f", fontWeight: "500" } : {}}
    >
      {title}
    </li>
  );
};
export default TabNavItem;
